import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ShieldOff, ArrowLeft } from 'lucide-react';

/**
 * Friendly "you don't have access to this section" page.
 * NO capability codes leak here — end users don't need to see
 * `personale.view` or similar internal identifiers.
 */
export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-10" data-testid="access-denied-page">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-stone-100 text-stone-500 flex items-center justify-center mx-auto mb-5">
          <ShieldOff className="w-7 h-7" />
        </div>
        <h1 className="font-display text-2xl md:text-3xl font-semibold text-brand-navy">Non hai accesso a questa sezione</h1>
        <p className="mt-2 text-stone-500 text-sm">
          Questa area è riservata. Se pensi di doverla vedere, contatta il tuo amministratore o responsabile.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-2 justify-center">
          <Button onClick={() => navigate('/foundation', { replace: true })}
            className="bg-brand-green hover:bg-brand-green-hover text-white gap-2"
            data-testid="access-denied-home">
            <ArrowLeft className="w-4 h-4" /> Torna alla home
          </Button>
        </div>
      </div>
    </div>
  );
}
